module.exports = __webpack_public_path__ + "img/hand.a1c9404b.svg";